import { IMedia } from "@/interfaces/media.interface";

import { CHAT_MEDIA_MAX_SIZE_PX, CHAT_VIDEO_MIN_WIDTH_PX } from "../../media-size";

interface VideoProps {
  media: IMedia;
  mediaURL: string;
}

const VideoMedia: React.FC<VideoProps> = ({ media, mediaURL }) => {
  const extension = media.extension;
  return (
    <video
      controls
      style={{
        maxWidth: `${CHAT_MEDIA_MAX_SIZE_PX}px`,
        maxHeight: `${CHAT_MEDIA_MAX_SIZE_PX}px`,
        minWidth: `${CHAT_VIDEO_MIN_WIDTH_PX}px`,
        objectFit: "cover",
        objectPosition: "center",
      }}
    >
      <source src={mediaURL} type={`video/${extension}`} />
      Your browser does not support this video format.
    </video>
  );
};

export default VideoMedia;
